import * as React from 'react'
import { Box, Typography } from '@mui/material'
import BigNumber from 'bignumber.js'
import useIsMobile from '../../hooks/useIsMobile'

export const PrecentChange = ({
    value,
    fontSize,
    lgFontSize,
    className,
    marginRight
}: {
    marginRight?: number
    className?: string
    lgFontSize?: number
    fontSize?: number
    value: BigNumber
}) => {
    const isUp = value.isPositive() || value.isZero()

    const isMobile = useIsMobile()

    return (
        <Typography
            component={'span'}
            className={className || ''}
            sx={{
                marginRight: marginRight ? marginRight : '0',
                color: isUp ? '#68F2B0' : '#FF3D3D',
                fontSize: !isMobile ? lgFontSize || 14 : fontSize || 18
            }}>
            <Arrow down={!isUp} />
            <span>{`${value.abs().toFixed(2)}%`}</span>
        </Typography>
    )
}

const Arrow = ({ down }: { down?: boolean }) => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                mr: 0.5,
                transform: down ? 'rotate(180deg)' : undefined
            }}>
            <svg viewBox='0 0 11 12' fill='currentColor' xmlns='http://www.w3.org/2000/svg' height={'0.65em'} width={'0.65em'}>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.469668 6.28033C0.176777 5.98744 0.176777 5.51256 0.469668 5.21967L4.71967 0.969668C5.01256 0.676777 5.48744 0.676777 5.78033 0.969668L10.0303 5.21967C10.3232 5.51256 10.3232 5.98744 10.0303 6.28033C9.7374 6.57322 9.2626 6.57322 8.9697 6.28033L6 3.31066V10.75C6 11.1642 5.66421 11.5 5.25 11.5C4.83579 11.5 4.5 11.1642 4.5 10.75V3.31066L1.53033 6.28033C1.23744 6.57322 0.762558 6.57322 0.469668 6.28033Z'
                />
            </svg>
        </Box>
    )
}
